export const COL_ESTADOS = {
  pendiente_empacar: { l: "Pendiente de empacar", c: "bg-zinc-200 text-zinc-700" },
  empacado: { l: "Empacado · por trasladar", c: "bg-amber-300 text-black" },
  trasladando: { l: "Trasladando", c: "bg-zinc-900 text-white" },
  colocado: { l: "Colocado en agencia", c: "bg-emerald-600 text-white" },
  recolectado: { l: "Recolectado", c: "bg-purple-100 text-purple-800" },
  revertido: { l: "Escaneo revertido", c: "bg-red-100 text-red-800" },
};

/** Liquidación de Cargo Expreso (solo consulta), separada de la entrega física. */
export const LiquidacionBadge = ({ o }) => {
  const l = o?.liquidacion;
  if (!l?.estado) return null;
  const liq = l.estado === "liquidado";
  return <div className={`mt-1 inline-block text-[10px] font-semibold rounded px-1.5 py-0.5 ${liq ? "bg-emerald-100 text-emerald-800" : "bg-orange-100 text-orange-800"}`} data-testid={`liquidacion-badge-${o.numero}`}>{liq ? `Liquidado #${l.numero} · ${l.fecha}` : "En proceso de liquidación"}</div>;
};

/** Estado de colocación (solo consulta). Solo aplica a envíos a departamento con «Se envía». */
export const ColocacionBadge = ({ o }) => {
  if (!o?.se_envia || !["departamento", "expreso"].includes(o.envio_tipo)) return null;
  const k = o.estado_colocacion || (["empacado", "listo"].includes(o.estado_empaque) ? "empacado" : "pendiente_empacar");
  const e = COL_ESTADOS[k] || COL_ESTADOS.pendiente_empacar;
  return <div className={`mt-1 inline-block text-[10px] font-semibold rounded px-1.5 py-0.5 ${e.c}`} title="Colocación (solo consulta)" data-testid={`colocacion-badge-${o.numero}`}>Colocación: {e.l}</div>;
};
